var customerId = $('.ga_customerId').val();

function addToCart(productObj,pageName,){
  
  var addToCartUrl = cartBaseUrl+addToCartEndPoint+customerId;
  $.blockUI({ message: '<img src="https://cdn.shopify.com/s/files/1/0820/8999/files/new-butterfly_1.gif?15302941410807159202" style="width:160px;height:auto;"><p>Please wait</p>',
                   css:{
                     'padding-bottom':'20px',
                      background: 'rgba(0, 0, 0, 0.4)',
                      border:'#4c4c4c',
                      color:'#fff',
                     'border-radius':'6px'
                   }
                   });
  var responseStatus = 200;
  
  var productId = (productObj.productId).toString();
  var variantId = (productObj.variantId).toString();
  var addToCartObj = {};
  addToCartObj["product_id"] = productId;
  addToCartObj["variant_id"] = variantId;
  
  var jsonString = JSON.stringify(addToCartObj);
  $.ajax({
        async:false,
        type: 'POST',
        timeout: ajaxCallTimeout,
        dataType: 'json',
        contentType: 'application/json',
        error: function (data) {
          $.unblockUI();
          responseStatus = data.status;
        },
        url: addToCartUrl,
        headers: getV3Header(),
        data:jsonString,
        beforeSend: function () {
        },
        complete: function () {
        },
        statusCode: {
            201: function (data) {
              responseStatus = 200;
              if(typeof ("storage") !== "undefined"){
                localStorage.setItem("cart_variant_id"+variantId,variantId);
                localStorage.setItem("cart_product_id"+productId,productId);
                
                
                var localStorageCartLineItemsArray = [];
                var cartLineItemsArray = [];
                    
                var localStorageWishlistLineItemsArray = [];
                
                var isProductDetailObjExists = localStorage.hasOwnProperty("productDetail");
                if(isProductDetailObjExists === true){
                  var addToCartLocalStorageObj = JSON.parse(localStorage.getItem("productDetail"));
                  if(!($.isEmptyObject(addToCartLocalStorageObj))){
                    
//                     function to update cart detail
                    if(addToCartLocalStorageObj.cartLinrItemsArray !== null 
                       && addToCartLocalStorageObj.cartLinrItemsArray !== undefined){
                      localStorageCartLineItemsArray = addToCartLocalStorageObj.cartLinrItemsArray;
                      if(localStorageCartLineItemsArray.length>0){
                        var addedCartObject = {};
                        addedCartObject["productId"] = productId;
                        addedCartObject["variantId"] = variantId;
                        localStorageCartLineItemsArray.push(addedCartObject);
                      }
                      else{
                        cartLineItemsArray = [];
                        var addedCartObject = {};
                        addedCartObject["productId"] = productId;
                        addedCartObject["variantId"] = variantId;
                        cartLineItemsArray.push(addedCartObject);
                      }
                    }
                    else{
                        cartLineItemsArray = [];
                        var addedCartObject = {};
                        addedCartObject["productId"] = productId;
                        addedCartObject["variantId"] = variantId;
                        cartLineItemsArray.push(addedCartObject);
                    }
                    
                    if(addToCartLocalStorageObj.wishlistLineItemsArray !== null &&
                      addToCartLocalStorageObj.wishlistLineItemsArray !== undefined ){
                      localStorageWishlistLineItemsArray = addToCartLocalStorageObj.wishlistLineItemsArray;
                    }
                    else{
                      localStorageWishlistLineItemsArray = [];
                    }
                  }
                }
                else{
                      var addedCartObject = {};
                      addedCartObject["productId"] = productId;
                      addedCartObject["variantId"] = variantId;
                      cartLineItemsArray.push(addedCartObject);
                }
                var localStorageObj = {}
                if(localStorageCartLineItemsArray.length>0){
                  localStorageObj["cartLinrItemsArray"] = localStorageCartLineItemsArray;
                }
                else{
                  localStorageObj["cartLinrItemsArray"] = cartLineItemsArray;
                }
                
                localStorageObj["wishlistLineItemsArray"] = localStorageWishlistLineItemsArray;
              }
              var localStorageJsonString = JSON.stringify(localStorageObj);
              localStorage.setItem("productDetail",localStorageJsonString);
              ga_addToCart(productObj,pageName);
              fb_addToCart(productObj);
              updateCartCount(customerId)
            },
            302: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
            },
            403: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
            400: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
          416: function(data){
            var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
          },
            422: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
            },
            500: function (data) {
              var responseErrorObj = JSON.parse(data.responseText);
              var errorObj = responseErrorObj.error;
              var errorMessage = errorObj.message;
                swal({
                    title: '',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            }
        }
    });
  return responseStatus;
}
